import ItemPreparationStep from '~/components/cms/custom/ItemPreparationStep.vue';
import ItemImageText from '@/components/cms/custom/ItemImageText/ItemImageText.vue';
import RichText from '~/components/ui/RichText.vue';
export default defineComponent({
  name: 'BlockEnumerationPhased',
  components: {
    ItemPreparationStep: ItemPreparationStep,
    ItemImageText: ItemImageText,
    RichText: RichText
  },
  props: {
    title: String,
    catchphrase: String,
    tabCatchphrase: String,
    note: {
      type: Object,
      default: null
    },
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    classes: {
      type: Object,
      default: function _default() {}
    }
  },
  setup: function setup() {
    var options = {
      renderNode: {
        paragraph: function paragraph(node, next) {
          return "\n        <p class=\"note\">".concat(next(node.content), "</p>");
        }
      }
    };
    return {
      options: options
    };
  }
});